<div class="popover-wrapper">
  <div class="header" (click)="openAllDocMode()">
    <div class="title">
      @if (!isSingleDocMode()) {
        <div>
          <span class="number-circle">{{numDocuments}}</span>
          Pending Documents
        </div>
      }
      @if (isSingleDocMode()) {
        <div class="clickable">
          <span>
            <i class="fas fa-chevron-left"></i>
          </span>
          Back to Pending Documents
        </div>
      }
    </div>
  </div>
  <div class="content">
    @if (numDocuments == 0) {
      <div class="row">
        <div class="col-12">
          All uploaded documents have been processed!
        </div>
      </div>
    }
    @if (!isSingleDocMode() && hasDocuments()) {
      <div>
        @for (documentQueueItem of documentQueueItems; track documentQueueItem; let idx = $index) {
          <div>
            <app-parsing-tracker-item
              [fileName]="documentQueueItem.processingJobPayload.documentFile?.originalDocumentName"
              [fileSuffix]="documentQueueItem.fileSuffix"
              [isError]="documentQueueItem.status == 'ERROR'"
              [step]="documentQueueItem.step"
              [status]="documentQueueItem.status"
              [borrowerName]="documentQueueItem.processingJobPayload.company.name"
              [documentId]="documentQueueItem.id"
              (openSingleDocMode)="openSingleDocMode(idx)"
              >
            </app-parsing-tracker-item>
          </div>
        }
      </div>
    }

    @if (isSingleDocMode() && numDocuments > 0) {
      <div>
        <div class="row">
          <div class="col-12">
            <app-parsing-tracker-status
              [error]="currentDocument?.status == 'ERROR'"
              [errorType]="currentDocument?.exceptionClass"
              [errorDescription]="currentDocument?.exceptionMessage"
              [userError]="currentDocument?.userError"
              [steps]="steps"
              [fileType]="currentDocument?.fileSuffix"
              [fileName]="currentDocument?.processingJobPayload.documentFile?.originalDocumentName"
              [borrowerName]="currentDocument?.processingJobPayload?.company?.name"
              [step]="currentDocument?.step"
              (goToDocumentPasswordEntry)="goToDocumentPasswordEntry()"
              >
            </app-parsing-tracker-status>
          </div>
        </div>
      </div>
    }
  </div>
  @if (isSingleDocMode()) {
    <div class="footer">
      @if (showLinkButtons()) {
        <div class="d-flex">
          @if (documentIsEligibleForTableDrawing) {
            @if (isManualReviewer) {
              <button class="btn btn-primary" (click)="goToTableIdentification()" [disabled]="!isInTableIdentification()">{{tableIdLabel}}</button>
            }
            @if (isManualReviewer && !earlyClassificationUIEnabled) {
              <button class="btn btn-primary" (click)="goToTableTabulation()" [disabled]="!isInTableTabulation()">Adjust Columns</button>
            }
          }
          @if (isManualReviewer) {
            <button class="btn btn-primary" (click)="goToManualReview()" [disabled]="!isInReview()">{{dataReviewLabel}}</button>
          }
          @if (isSpreader) {
            <button class="btn btn-primary" (click)="goToSpreading()" [disabled]="!isReadyForSpreading()">{{spreadLabel}}</button>
          }
        </div>
      }
    </div>
  }
</div>
